module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-card-title', [_c('h2', [_vm._v("\n                Personal Access Tokens\n            ")])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showCreateTokenForm($event)
      }
    }
  }, [_vm._v("\n                        Create New Token\n                    ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.tokens.length === 0) ? _c('p', {
    staticClass: "mb-0 mt-2"
  }, [_vm._v("\n                        You have not created any personal access tokens.\n                    ")]) : _vm._e()])], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "offset-xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.tsearch),
      callback: function($$v) {
        _vm.tsearch = $$v
      },
      expression: "tsearch"
    }
  })], 1)], 1), _vm._v(" "), (_vm.tokens.length > 0) ? _c('v-data-table', {
    staticClass: "elevation-0",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.tokens,
      "search": _vm.tsearch,
      "select-all": "",
      "pagination": _vm.pagination,
      "item-key": "name"
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_vm._l((props.headers), function(header) {
          return _c('th', {
            key: header.text,
            class: ['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : ''],
            attrs: {
              "align": "left"
            },
            on: {
              "click": function($event) {
                _vm.changeSort(header.value)
              }
            }
          }, [_c('v-icon', [_vm._v("arrow_upward")]), _vm._v("\n                            " + _vm._s(header.text) + "\n                        ")], 1)
        }), _vm._v(" "), _c('th')], 2)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v("\n                            " + _vm._s(props.item.name) + "\n                        ")]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "error",
          attrs: {
            "small": ""
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.revoke(props.item)
            }
          }
        }, [_vm._v("\n                                Delete\n                            ")])], 1)])]
      }
    }])
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": ""
    },
    model: {
      value: (_vm.dialog1),
      callback: function($$v) {
        _vm.dialog1 = $$v
      },
      expression: "dialog1"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Create Token")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', [_vm._l((_vm.form.errors), function(error) {
    return _c('v-layout', {
      key: error.id,
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n                            " + _vm._s(error) + "\n                        ")])], 1)
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name",
      "name": "name",
      "hint": "Something your users will recognize and trust.",
      "id": "create-token-name"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1)], 1), _vm._v(" "), (_vm.scopes.length > 0) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('h4', [_vm._v(" Scopes ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": _vm.scope.id,
      "name": "redirect",
      "id": "create-client-redirect",
      "checked": _vm.scopeIsAssigned(_vm.scope.id)
    },
    on: {
      "click": function($event) {
        _vm.toggleScope(_vm.scope.id)
      }
    }
  }, [_vm._v("\n                                dark\n                                >")])], 1)], 1) : _vm._e()], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog1 = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.store($event)
      }
    }
  }, [_vm._v("Create")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": ""
    },
    model: {
      value: (_vm.dialog2),
      callback: function($$v) {
        _vm.dialog2 = $$v
      },
      expression: "dialog2"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Personal Access Token")])]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("\n                    Here is your new personal access token. This is the only time it will be shown so don't lose it!\n                    You may now use this token to make API requests.\n                ")]), _vm._v(" "), _c('pre', [_c('code', [_vm._v(_vm._s(_vm.accessToken))])])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog2 = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-754199b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/passport/PersonalAccessTokens.vue
// module id = 330
// module chunks = 0